import type { ProviderType } from "@/core/types";

type CredentialOption = { id: string; name: string };

const BHS_CREDENTIALS = [
  { id: "Ph.D.", name: "Ph.D." },
  { id: "Psy.D.", name: "Psy.D." },
  { id: "LCSW", name: "LCSW" },
  { id: "LCSW-R", name: "LCSW-R" },
  { id: "LMFT", name: "LMFT" },
  { id: "LMHC", name: "LMHC" },
  { id: "LMSW", name: "LMSW" },
  { id: "RN", name: "RN" },
] as const satisfies CredentialOption[];

const BHS_INTAKE_CREDENTIALS = [
  { id: "Ph.D.", name: "Ph.D." },
  { id: "Psy.D.", name: "Psy.D." },
] as const satisfies CredentialOption[];

const PRESCRIBER_CREDENTIALS = [
  { id: "PMHNP-BC", name: "PMHNP-BC" },
  { id: "MD", name: "MD" },
] as const satisfies CredentialOption[];

const PEER_CREDENTIALS = [
  { id: "Certified Peer Specialist", name: "Certified Peer Specialist" },
] as const satisfies CredentialOption[];

const CASE_MANAGER_CREDENTIALS = [{ id: "RN", name: "RN" }] as const satisfies CredentialOption[];

export const CREDENTIALS_BY_PROVIDER_TYPE: Record<ProviderType, CredentialOption[]> = {
  BEHAVIORAL: BHS_CREDENTIALS,
  BEHAVIORAL_INTAKE: BHS_INTAKE_CREDENTIALS,
  CARE_MANAGER: [],
  CASE_MANAGER: CASE_MANAGER_CREDENTIALS,
  CASE_MANAGER_SUPERVISOR: CASE_MANAGER_CREDENTIALS,
  PCP: [],
  PEER: PEER_CREDENTIALS,
  PRESCRIBE: PRESCRIBER_CREDENTIALS,
};
